import { createSlice } from '@reduxjs/toolkit';

const gameProvidersSlice = createSlice({
  name: 'gameProviders',
  initialState: {
    sourceNameById: {},
    collections: [],
    allCasino: [],
    category: {
      collectionId: null,
      categories: []
    },
    categoryGames: {
      categoryId: null,
      list: []
    },
    selectGame: {}
  },
  reducers: {
    setAddCollections: (state, action) => {
      state.collections.push(action.payload);
      state.collections.sort((a, b) => a.name.localeCompare(b.name));
    },
    setUpdateCollection: (state, action) => {
      const { id, data } = action.payload;
      const collection = state.collections.find((el) => el.id === id);
      if (collection) Object.assign(collection, data);
      state.collections.sort((a, b) => a.name.localeCompare(b.name));
    },
    setDeleteCollections: (state, action) => {
      const idDeleted = action.payload;
      state.collections = state.collections.filter((el) => el.id !== idDeleted);
      state.collections.sort((a, b) => a.name.localeCompare(b.name));
    },
    setCollections: (state, action) => {
      state.collections = action.payload;
      state.collections.sort((a, b) => a.name.localeCompare(b.name));
    },
    setAllCasino: (state, action) => {
      state.allCasino = action.payload;
    },
    setCategoriesInfo: (state, action) => {
      state.category = action.payload;
    },
    setCategories: (state, action) => {
      const { collectionId, list } = action.payload;
      if (state.category.collectionId == collectionId) {
        state.category.categories = list;
      }
    },
    setCategoryGames: (state, action) => {
      state.categoryGames = action.payload;
    },
    updateCategoryGame: (state, action) => {
      const gameInfo = action.payload;
      const categoryGames = state.categoryGames;
      const games = state.categoryGames.list;

      const gameItem = [
        gameInfo.id,
        gameInfo.name,
        gameInfo.originName,
        gameInfo.uuid,
        gameInfo.source,
        gameInfo.image,
        gameInfo.type,
        gameInfo.provider,
        gameInfo.hasFreeSpins,
        gameInfo.freespinFullDay,
        gameInfo.priority,
        gameInfo.enabled,
        gameInfo.hit,
        gameInfo.providerName,
        gameInfo.sourceGameId,
        gameInfo.sportBook
      ];

      if (categoryGames.categoryId != gameInfo.categoryId) return;

      let currentGameIndx = games.findIndex((el) => el[0] == gameInfo.id);

      // sportBook
      if (gameItem[15]) {
        games.forEach((game, indx) => {
          const newGame = [...game];
          newGame[15] = false;
          games[indx] = newGame;
        });
      }

      // если нет текущего то добавляем
      if (currentGameIndx < 0) {
        const insertIndex = games.findIndex((el) => el[10] >= gameInfo.priority);

        if (insertIndex === -1) {
          games.push(gameItem); // в конец (самый большой)
        } else {
          games.splice(insertIndex, 0, gameItem); // перед первым с большим
        }
        return;
      }

      // обновляем существующий
      games[currentGameIndx] = gameItem;
    },
    deleteCategoryGame: (state, action) => {
      const gameInfo = action.payload;
      const categoryGames = state.categoryGames;
      const games = state.categoryGames.list;

      if (categoryGames.categoryId != gameInfo.categoryId) return;

      state.categoryGames.list = games.filter((el) => el[0] !== gameInfo.id);
    },
    setSelectGame(state, action) {
      state.selectGame = action.payload;
    },
    setSourceNameById(state, action) {
      state.sourceNameById = action.payload;
    }
  }
});

export default gameProvidersSlice.reducer;

export const {
  setCollections,
  setAllCasino,
  setAddCollections,
  setUpdateCollection,
  setCategories,
  setCategoriesInfo,
  setCategoryGames,
  setDeleteCollections,
  updateCategoryGame,
  deleteCategoryGame,
  setSourceNameById,
  setSelectGame
} = gameProvidersSlice.actions;
